import {
  INICIALITZAR,
  INTRODUCCIO_OBTENIR_DADES
} from "../../actions/actionTypes";

const ESTAT_INICIAL = {};

const classes = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INICIALITZAR:
      return ESTAT_INICIAL;

    case `${INTRODUCCIO_OBTENIR_DADES}_SUCCESS`:
      return action.payload && action.payload.classes
        ? action.payload.classes
        : {};

    default:
      return state;
  }
};

export default classes;

const classesIntroduccio = state => state.introduccio;

export const getClassesIntroduccio = state => {
  const classes = classesIntroduccio(state);
  if (!classes) {
    return null;
  }
  return classes;
};

export const getClassesIntroduccioAsArray = state => {
  const classesIndexatsPerId = classesIntroduccio(state);
  return Object.keys(classesIndexatsPerId).map(idClasse => ({
    ...classesIndexatsPerId[idClasse],
    id: parseInt(idClasse)
  }));
};
